import React from "react";
import { Avatar, Skeleton, Stack } from "@mui/material";
import { SkeletonListCard, SkeletonDetailRows } from "../Skeleton/SkeletonComponents";

const NotesListSkeleton = ({ count = 3 }) => (
  <SkeletonListCard
    count={count}
    listItemSx={{ py: 2, alignItems: 'flex-start', flexDirection: 'row', gap: 2 }}
    renderItem={() => (
      <>
        <Skeleton variant="circular" width={50} height={50} sx={{ flexShrink: 0 }} />
        <Stack sx={{ flex: 1 }} spacing={1}>
          <Stack direction="row" spacing={2}>
            <Skeleton variant="text" width="30%" height={20} />
            <Skeleton variant="text" width="20%" height={20} />
          </Stack>
          <SkeletonDetailRows widths={['80%', '60%']} />
        </Stack>
      </>
    )}
  />
);

export default NotesListSkeleton;
